export const AutoEvaluation = {
    path: '/auto_evaluate/:uuid/:type',
    name: 'auto_evaluate',
    component: () => import('@/views/Evaluation/EvaluationInterview/AutoEvaluation.vue'),
}